export default "__VITE_ASSET__BCGq$4qw__"